module.exports = {"PATH":"results","COMPANY":{"ID":"id","NAME":"name","SHIPPING_COMPANY":"shipping_company","IS_ACTIVE":"is_active"}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/kapida/platformConfigs/integrationMaps/cargoCompanies.json
// module id = 1791
// module chunks = 1